import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { Add_FoodPricePeriod_Api } from '../../API/FoodPricePeriodApi';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// تابع کمکی برای تبدیل کاراکترهای فارسی به لاتین
const persianToLatinDigits = (str) => {
  if (!str) return '';
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const latinDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  let newStr = str;
  for (let i = 0; i < 10; i++) {
    const regex = new RegExp(persianDigits[i], 'g');
    newStr = newStr.replace(regex, latinDigits[i]);
  }
  return newStr;
};

// =================================================================
export const AddFoodPricePeriodComponent = ({
  setLoading,
  showMessage,
  rowInserted,
  categoryId,
  categoryTitle,
  cancelInsert
}) => {
  // =================================================================
  const [form] = Form.useForm();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // =================================================================
  useEffect(() => {
    form.setFieldsValue({ isActive: true });
  }, []);

  // =================================================================
  const onSubmit = async (values) => {
    values.categoryId = categoryId;
    setLoading(true);
    try {
      let data = await Add_FoodPricePeriod_Api(values);
      setLoading(false);
      if (data.messageStatus === "Successful") {
        showMessage(data.message, "Successful");
        rowInserted();
      } else {
        showMessage(data.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور", "error");
    }
  };

  // =================================================================
  const onFinishFailed = (errorInfo) => {
    showMessage(errorInfo, "error");
  };

  // =================================================================
  return (
    <>
      <div className='sectionTitle'>
        <h2>
          اضافه کردن دوره قیمت گذاری غذا برای {categoryTitle}
        </h2>
      </div>
      <div className='container'>
        <Form
          name="basic"
          form={form}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="title"
            label="عنوان"
            rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
          >
            <Input placeholder='عنوان' />
          </Form.Item>

          <Form.Item
            name="from_Shamsi"
            label="از تاریخ"
            rules={[{ required: true, message: 'یک مقدار معتبر وارد کنید!' }]}
            getValueFromEvent={(value) => {
              setFromDate(value);
              const formattedDate = value ? value.format('YYYY-MM-DD') : "";
              return persianToLatinDigits(formattedDate);
            }}
          >
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              value={fromDate}
              onChange={(value) => setFromDate(value)}
              format="YYYY-MM-DD"
            />
          </Form.Item>

          <Form.Item
            name="to_Shamsi"
            label="تا تاریخ"
            rules={[{ required: true, message: 'یک مقدار معتبر وارد کنید!' }]}
            getValueFromEvent={(value) => {
              setToDate(value);
              const formattedDate = value ? value.format('YYYY-MM-DD') : "";
              return persianToLatinDigits(formattedDate);
            }}
          >
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              value={toDate}
              onChange={(value) => setToDate(value)}
              format="YYYY-MM-DD"
            />
          </Form.Item>

          <Form.Item
            name="orderIndex"
            label="ترتیب"
          >
            <InputNumber />
          </Form.Item>

          <Form.Item
            name="isActive"
            label="فعال"
            valuePropName='checked'
          >
            <Checkbox> </Checkbox>
          </Form.Item>
        </Form>
      </div>

      <Row className='sectionFooter'>
        <Col xs={0} sm={0} md={8} lg={16} xl={16}>
        </Col>
        <Col xs={12} sm={12} md={8} lg={4} xl={4}>
          <Button
            style={{ width: '98%' }}
            className='btn-primary'
            htmlType="submit"
            onClick={() => form.submit()}
          >
            <CheckOutlined />
            ذخیره
          </Button>
        </Col>
        <Col xs={12} sm={12} md={8} lg={4} xl={4}>
          <Button
            className='btn-secondary'
            style={{ width: '100%' }}
            onClick={() => cancelInsert()}
          >
            <RollbackOutlined />
            لغو
          </Button>
        </Col>
      </Row>
    </>
  );
};